import Card from 'components/card/Card';

import { IArticleCardList } from 'source/NFR.types';

const ArticleCardList: React.FC<IArticleCardList> = ({ list }) => {
  return (
    <ul className="article-card-list">
      {list?.map(articleCard => (
        <li className="article-card-list__item" key={articleCard.title}>
          <Card {...articleCard} />
        </li>
      ))}
    </ul>
  );
};

ArticleCardList.displayName = 'ArticleCardList';

export default ArticleCardList;
